import { browserName, isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import { useAuthState } from '../../services/auth';
import { useEffect } from 'react';
import { useEnterpriseStore as useEnterpriseStore } from '../../stores/enterprise.store';
import axios from 'axios';
import { useOperatorsState } from '../../services/OperatorsList';

export const Master = ({ children }: any) => {
  //const user = useUserState();
  const location = useLocation();
  const { token } = useAuthState();
  const { loggedUserData } = useOperatorsState();
  const updateEnterprise = useEnterpriseStore((state) => state.updateEnterprise);

  useEffect(() => {
    if (token) {
      console.log(token);
      getPolicy();
    }
  }, [token]);

  async function getPolicy() {
    // try {
    //   const resp: any = await axios.get(`/op/ama/enterprise`);
    //   console.log(resp?.data?.enterprise?.name);
    //   if (resp?.data?.enterprise?.name) {
    //     updateEnterprise(resp?.data?.enterprise);
    //   }
    // } catch (error) {
    //   updateEnterprise(null);
    //   console.log(error);
    // }
  }

  function isWebView() {
    return browserName.toLowerCase().includes('webview') || browserName.toLowerCase().includes('wkwebview');
  }

  return (
    <div
      className={
        'main-content-wrapper' +
        (loggedUserData ? ' pt-16' : '') +
        (!token ? ' no-navbar' : '') +
        (isMobileOnly && location.pathname === '/landing' ? ' mobile-content-wrapper' : '') +
        (isWebView() && location.pathname === '/landing' ? ' webview' : '')
      }
    >
      {children}
    </div>
  );
};
